import { render } from "./PatientData.vue?vue&type=template&id=1e58b50a"
import script from "./PatientData.vue?vue&type=script&lang=js"
export * from "./PatientData.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__